import { render, staticRenderFns } from "./GMVAmountShopDrawer.vue?vue&type=template&id=0d7867f2"
import script from "./GMVAmountShopDrawer.vue?vue&type=script&lang=ts"
export * from "./GMVAmountShopDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports